const state = {
    itens: [],
    item: {
        address: '',
        city: {
            id: '',
            name: '',
            state: {
                id: '',
                name: ''
            }
        },
        name: '',
        is_active: false,
        goals : []
    }
};

export default state;